import { proxyPivotAPI } from "../../../config";

const getAllSubscriptionDashboard = (query) => {
    return proxyPivotAPI.get("/elk/subscription/dashboard/", { params: { ...query } });
};

export default getAllSubscriptionDashboard;
